import pluralize from 'pluralize'
import uniq from 'lodash/uniq'

const createByBadgeReducer =
  (entityName) =>
  (state = {}, action) => {
    const pluralEntityName = pluralize(entityName, 2)

    switch (action.type) {
      case `FETCH_${pluralEntityName.toUpperCase()}_SUCCESS`:
        return {
          ...state,
          ...action.entities.reduce((acc, entity) => {
            entity.badges &&
              entity.badges.forEach((badge) => {
                if (acc[badge]) {
                  acc[badge] = uniq([...acc[badge], entity.id])
                } else {
                  acc[badge] = [entity.id]
                }
              })

            return acc
          }, {}),
        }
      default:
        return state
    }
  }

export default createByBadgeReducer
